export default __webpack_public_path__ + "static/graph-feature-f23fb46cea26125387ee0ebfb37ad990.png";